import { Component, OnInit, Input } from "@angular/core";
import { IEntity } from "@schema/entity";

@Component({
  selector: "app-data-grid-cell",
  templateUrl: "./cell.component.html",
  styleUrls: ["./cell.component.scss"]
})
export class DataGridCellComponent<TGenericEntity extends IEntity> implements OnInit {

  /**
   * Column info
   */
  @Input()
  public column: any;

  /**
   * The entity
   */
  @Input()
  public entity: TGenericEntity;

  /**
   * Check if the cell is a date (for auto-formatting)
   */
  get isDate(): boolean {
    return this.entity[this.column.property] instanceof Date;
  }

  /**
   * Get the text value of the cell
   */
  get value() {
    return (typeof this.entity[this.column.property] === "undefined") ? "" : this.entity[this.column.property];
  }

  constructor() { }

  ngOnInit(): void {
  }

}
